import { FC } from 'react';
import styled, { useTheme } from 'styled-components';

import { useNavigation } from '#/hooks/useNavigation';
import { ThemeConfig } from '#/service/config/config.types';
import { remify } from '#/service/utils';
import { tb } from '#/store/translation/translation.store';

const LogoItem = styled.img`
  width: ${remify(102)};
  min-width: ${remify(102)};
  cursor: pointer;
`;

export const Logo: FC = () => {
  const theme = useTheme() as ThemeConfig;
  const { goHome } = useNavigation('Footer/Logo');

  return (
    <LogoItem
      alt={tb('tts.app.logo')}
      aria-hidden="true"
      onClick={goHome}
      src={theme.logo?.secondary ?? theme.logo?.primary}
    />
  );
};
